
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { CaseFormData } from "../CaseForm";

interface TemplateSelectProps {
  form: UseFormReturn<CaseFormData>;
}

export function TemplateSelect({ form }: TemplateSelectProps) {
  const { data: templates = [], isLoading: isLoadingTemplates } = useQuery({
    queryKey: ["case-templates"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("case_templates")
        .select("*");
      
      if (error) throw error;
      return data;
    },
  });

  return (
    <FormField
      control={form.control}
      name="template_type"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Velg saksmal (valgfritt)</FormLabel>
          <Select
            onValueChange={field.onChange}
            value={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Velg en mal" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="no_template">Ingen mal</SelectItem>
              {templates.map((template) => (
                <SelectItem 
                  key={template.id} 
                  value={template.template_type || template.id}
                >
                  {template.title}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
